import React from 'react';
import ReactDOM from 'react-dom/client';
import * as smoothscroll from 'smoothscroll-polyfill';
import './app/onesignal/init';
import App from './App';
import './index.css';

smoothscroll.polyfill();
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
